import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ShareModule } from "ngx-sharebuttons";
import { ShareButtonsModule } from "ngx-sharebuttons/buttons";
import { ShareIconsModule } from "ngx-sharebuttons/icons";
import { EdpEShareButtonsMgmComponent } from "./edp-e-share-buttons-mgm.component";
import { TranslateModule } from "@ngx-translate/core";
import { EdpEMgmMailModalComponent } from "@edp-components/edp-e-mgm-mail-modal/edp-e-mgm-mail-modal.component";
import { ReactiveFormsModule } from "@angular/forms";
import { EdpEMgmMailModalModule } from "@edp-components/edp-e-mgm-mail-modal/edp-e-mgm-mail-modal.module";

@NgModule({
    declarations: [EdpEShareButtonsMgmComponent],
    imports: [
        CommonModule,
        ShareModule,
        ShareButtonsModule,
        ShareIconsModule,
        TranslateModule,
        ReactiveFormsModule,
        EdpEMgmMailModalModule,
    ],
    exports: [EdpEShareButtonsMgmComponent],
    entryComponents: [EdpEMgmMailModalComponent],
})
export class EdpEShareButtonsMgmModule {}
